// @ts-nocheck
import * as React from 'react';
import classNames from 'classnames';
import { Form,  Tooltip } from 'antd';
import './validation.scss';
import Icon from 'atoms/icons/icon';
import { getGridMetadata } from 'models/dynamicGrid/selector';
import { useSelector } from 'react-redux';

const OrderValidation = (props: any) => {
    const { 
        children, 
        hasError, 
        errorMessage, 
        hasWarning, 
         tableId, 
        row, 
        rowIdentifier,
        isTouched 
    } = props;
    
    const gridMetaData = useSelector(state => getGridMetadata(state, tableId));
    const hasGridEditOperationDisabled = gridMetaData?.isGridEditDisabledOverride;
    
     const shouldShowIndicator = (hasError || hasWarning) && isTouched;

    const classes: any = classNames(['validation-form-item', { 'validation-form-item-theme': props.isTheme }, { 'validation-edit-disabled': hasGridEditOperationDisabled }]);
     const validationStatus = shouldShowIndicator ? 'error' : row?.[rowIdentifier]?.isUpdated && 'success';
    
    return (
        <Form.Item 
            className={classes} 
            validateStatus={validationStatus} 
        >
            <div className="validation">
                <div className="validation--input">{children}</div>
                {shouldShowIndicator && (
                    <Tooltip placement="topLeft" title={errorMessage} arrowPointAtCenter>
                        <div>
                            <Icon
                                extraClass={hasWarning ? 'warning' : 'error'}
                                faAlias="faInfoCircle"
                                size="small"
                            ></Icon>
                        </div>
                    </Tooltip>
                )}
            </div>
        </Form.Item>
    );
};

export default OrderValidation;